import { useEffect } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
// import { FaCaretLeft, FaCaretRight } from "react-icons/fa";

// import moment from "moment-timezone";
// import { FlagIcon } from "react-flag-kit";
// import { useSelector } from "react-redux";
// import { FaChalkboardUser } from "react-icons/fa6";

import CardSchedule from "../../CardSchedule";
import PlaceholderText from "../../Placeholder/PlaceholderText";
import { getClassWithoutTeacher } from "../../../store/middleware";
import { SCButtonAddInput } from "../../../components/Buttons/styles";
import { endLoading, initLoading } from "../../../store/slices/generics.slice";

import { Container, BoxClasses, ColumnsClasses, WrappreTitle, Label } from "./styles";

function ClassesWithoutTeacher() {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const { classesWithoutTeacher } = useSelector((state) => state.companyManagerReducer);
  const { classesWithoutTeacherDemo } = useSelector((state) => state.companyManagerReducer);

  const getData = async () => {
    dispatch(initLoading());

    await dispatch(getClassWithoutTeacher(false));
    await dispatch(getClassWithoutTeacher(true));

    dispatch(endLoading());
  };

  useEffect(() => {
    getData();
    // eslint-disable-next-line
  }, []);

  return (
    <Container>
      <BoxClasses>
        <ColumnsClasses>
          <WrappreTitle>
            <Label>{t("CLASSES")}</Label>

            <div>
              {/* <CurrentTime>Horário atual</CurrentTime>
              <Time>
                <FaCaretLeft size={18} color="#004fff" />
                14:30h
                <FaCaretRight size={18} color="#004fff" />
              </Time> */}
            </div>
          </WrappreTitle>

          {classesWithoutTeacher?.length > 0 ? (
            classesWithoutTeacher?.map((schedule) => (
              <CardSchedule key={JSON.stringify(schedule)} schedule={schedule} />
            ))
          ) : (
            <PlaceholderText />
          )}
        </ColumnsClasses>

        <ColumnsClasses>
          <WrappreTitle>
            <Label>{t("DEMO_CLASS")}</Label>

            <div>
              {/* <CurrentTime>Horário atual</CurrentTime>
              <Time>
                <FaCaretLeft size={18} color="#004fff" />
                14:30h
                <FaCaretRight size={18} color="#004fff" />
              </Time> */}
            </div>
          </WrappreTitle>

          {classesWithoutTeacherDemo?.length > 0 ? (
            classesWithoutTeacherDemo?.map((schedule) => (
              <CardSchedule key={JSON.stringify(schedule)} schedule={schedule} />
            ))
          ) : (
            <PlaceholderText />
          )}
        </ColumnsClasses>
      </BoxClasses>

      <Link to={`/calendar/`}>
        <SCButtonAddInput mt="15px" ml="auto" mb="0" mr="auto" background="#004fff" color="#fff">
          {t("BTN_VIEW_ALL")}
        </SCButtonAddInput>
      </Link>
    </Container>
  );
}

export default ClassesWithoutTeacher;

// return (
//   <div className="classesWithoutTeacherBox">
//     {!classesWithoutTeacher?.length ? (
//       <PlaceholderText />
//     ) : (
//       classesWithoutTeacher.map((classWithoutTeacher) => {
//         const {
//           id,
//           type,
//           student = {},
//           createdAt,
//           lingoLanguage,
//           timeTotal,
//           teacherLanguageType,
//         } = classWithoutTeacher;
//         const container = classWithoutTeacher.container || {};
//         let studentLevel = null;
//         if (student && student.studentLevelGrades) {
//           const levelFound = student.studentLevelGrades.find(
//             ({ lingoLanguageId }) => lingoLanguage.id === lingoLanguageId,
//           );
//           studentLevel = levelFound ? levelFound.level.level : null;
//         }
//         studentLevel = studentLevel || container.levelByLingo;
//         let studentName = (student && student.user && student.user.name) || "";
//         studentName = studentName || container.studentName;

//         return (
//           <div key={JSON.stringify(classWithoutTeacher)} className="new-box classWithoutTeacherBox">
//             <p className="classWithoutTeacherDate">{timeTotal}</p>
//             <div className="classWithoutTeacherInfoBox">
//               <FlagIcon code={lingoLanguage.flag} size={18} />
//               <div className="classWithoutTeacherInfo">
//                 <p>{lingoLanguage.language.name}</p>
//                 <p>
//                   {t("CARD_CLASS_STUDENT")}: {studentName} • {t("CARD_PLAN_LEVEL")}: {studentLevel}
//                   <span className="spanBlue">
//                     {teacherLanguageType && " • " + t(teacherLanguageType.toUpperCase())}
//                   </span>
//                 </p>
//                 <p>
//                   {t("DATE_CREATED")}: {moment(createdAt).format("DD/MM/YYYY")}
//                 </p>
//               </div>
//               <div className="classWithoutTeacherButtonBox">
//                 <Link to={`/class-details/${id}`}>
//                   <button>
//                     View <i className="fa fa-angle-right" />
//                   </button>
//                 </Link>
//                 {student?.isTraining && <FaChalkboardUser size={20} color={"#004fff"} />}
//                 {type === "first" && <p>{t("FIRST_CLASS")}</p>}
//                 {type === "trial" && <p>{t("TRIAL_CLASS")}</p>}
//               </div>
//             </div>
//           </div>
//         );
//       })
//     )}
//   </div>
// );
